export function timeAgo(dateString) {
    var now = new Date();
    var date = new Date(dateString);
    var diffInMs = now.getTime() - date.getTime();
    var seconds = Math.floor(diffInMs / 1000);
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    var weeks = Math.floor(days / 7);
    var months = Math.floor(days / 30); // Approximate 30 days per month
    var years = Math.floor(days / 365); // Approximate 365 days per year
    if (years >= 1) {
        return "More than 1 year ago";
    }
    if (months >= 1) {
        return months === 1 ? "1 month ago" : "".concat(months, " months ago");
    }
    if (weeks >= 1) {
        return weeks === 1 ? "1 week ago" : "".concat(weeks, " weeks ago");
    }
    if (days >= 1) {
        return days === 1 ? "1 day ago" : "".concat(days, " days ago");
    }
    if (hours >= 1) {
        return hours === 1 ? "1 hour ago" : "".concat(hours, " hours ago");
    }
    if (minutes >= 1) {
        return minutes === 1 ? "1 minute ago" : "".concat(minutes, " minutes ago");
    }
    return seconds === 1 ? "1 second ago" : "".concat(seconds, " seconds ago");
}
